import React from 'react'
import Checkbox from '@components/Checkbox'
import PropTypes from 'prop-types'

function PermissionCheckbox ({
  item,
  toggleItem,
  isSelected,
  itemToString,
  disabled
}) {
  return (
    <Checkbox
      key={item}
      value={isSelected(item)}
      disabled={disabled}
      label={itemToString(item)}
      onChange={() => toggleItem(item)}
    />
  )
}

PermissionCheckbox.propTypes = {
  item: PropTypes.any,
  toggleItem: PropTypes.func,
  isSelected: PropTypes.func,
  itemToString: PropTypes.func,
  disabled: PropTypes.bool
}

function getDefaultPermissionsByPosition (positionId, staticData) {
  const { PERMISSIONS, EMPLOYEE_POSITIONS } = staticData.CONST

  switch (positionId) {
    case EMPLOYEE_POSITIONS.ACCOUNTING:
      return [
        PERMISSIONS.BASIC_INTERNAL,
        PERMISSIONS.ZOOM_MANAGEMENT,
        PERMISSIONS.PROJECT_MANAGEMENT,
        PERMISSIONS.ADVANCED_REPORTING,
        PERMISSIONS.ACCOUNTING,
        PERMISSIONS.ADVANCED_EXPERT_MANAGEMENT,
        PERMISSIONS.BASIC_SHERLOCK
      ]

    case EMPLOYEE_POSITIONS.ADMIN:
      return [
        PERMISSIONS.BASIC_INTERNAL,
        PERMISSIONS.ZOOM_MANAGEMENT,
        PERMISSIONS.ADMIN,
        PERMISSIONS.PROJECT_MANAGEMENT,
        PERMISSIONS.ADVANCED_REPORTING,
        PERMISSIONS.ACCOUNTING,
        PERMISSIONS.HR,
        PERMISSIONS.FEE_MANAGEMENT,
        PERMISSIONS.BASIC_SHERLOCK
      ]

    case EMPLOYEE_POSITIONS.ASSOCIATE:
      return [
        PERMISSIONS.BASIC_INTERNAL,
        PERMISSIONS.ZOOM_MANAGEMENT,
        PERMISSIONS.BASIC_SHERLOCK
      ]

    case EMPLOYEE_POSITIONS.ASSOCIATE_INTERN:
      return [
        PERMISSIONS.BASIC_INTERNAL,
        PERMISSIONS.ZOOM_MANAGEMENT,
        PERMISSIONS.BASIC_SHERLOCK
      ]

    case EMPLOYEE_POSITIONS.TEAM_LEADER:
      return [
        PERMISSIONS.BASIC_INTERNAL,
        PERMISSIONS.PROJECT_MANAGEMENT,
        PERMISSIONS.ZOOM_MANAGEMENT,
        PERMISSIONS.BASIC_SHERLOCK
      ]

    case EMPLOYEE_POSITIONS.BD:
      return [
        PERMISSIONS.BASIC_INTERNAL,
        PERMISSIONS.ZOOM_MANAGEMENT,
        PERMISSIONS.PROJECT_MANAGEMENT,
        PERMISSIONS.ADVANCED_REPORTING,
        PERMISSIONS.BASIC_SHERLOCK
      ]

    case EMPLOYEE_POSITIONS.ERM:
      return [
        PERMISSIONS.BASIC_INTERNAL,
        PERMISSIONS.ZOOM_MANAGEMENT,
        PERMISSIONS.PROJECT_MANAGEMENT,
        PERMISSIONS.ADVANCED_EXPERT_MANAGEMENT,
        PERMISSIONS.BASIC_SHERLOCK
      ]

    case EMPLOYEE_POSITIONS.EXECUTIVE:
      return [
        PERMISSIONS.BASIC_INTERNAL,
        PERMISSIONS.ZOOM_MANAGEMENT,
        PERMISSIONS.PROJECT_MANAGEMENT,
        PERMISSIONS.ADVANCED_REPORTING,
        PERMISSIONS.ADVANCED_EXPERT_MANAGEMENT,
        PERMISSIONS.HR,
        PERMISSIONS.BASIC_SHERLOCK
      ]

    case EMPLOYEE_POSITIONS.HR:
      return [
        PERMISSIONS.BASIC_INTERNAL,
        PERMISSIONS.ZOOM_MANAGEMENT,
        PERMISSIONS.HR,
        PERMISSIONS.BASIC_SHERLOCK
      ]

    case EMPLOYEE_POSITIONS.IT_ADMIN:
      return [
        PERMISSIONS.BASIC_INTERNAL,
        PERMISSIONS.ZOOM_MANAGEMENT,
        PERMISSIONS.ACCOUNTING,
        PERMISSIONS.ADMIN,
        PERMISSIONS.ADVANCED_EXPERT_MANAGEMENT,
        PERMISSIONS.ADVANCED_REPORTING,
        PERMISSIONS.BASIC_INTERNAL,
        PERMISSIONS.FEE_MANAGEMENT,
        PERMISSIONS.HR,
        PERMISSIONS.PROJECT_MANAGEMENT,
        PERMISSIONS.BASIC_SHERLOCK
      ]
    case EMPLOYEE_POSITIONS.MARKETING:
      return [
        PERMISSIONS.BASIC_INTERNAL,
        PERMISSIONS.ZOOM_MANAGEMENT,
        PERMISSIONS.BASIC_SHERLOCK
      ]

    case EMPLOYEE_POSITIONS.OPS_MANAGEMENT:
      return [
        PERMISSIONS.BASIC_INTERNAL,
        PERMISSIONS.ZOOM_MANAGEMENT,
        PERMISSIONS.PROJECT_MANAGEMENT,
        PERMISSIONS.ADVANCED_REPORTING,
        PERMISSIONS.BASIC_SHERLOCK
      ]

    case EMPLOYEE_POSITIONS.ACCOUNT_MANAGER:
      return [
        PERMISSIONS.BASIC_INTERNAL,
        PERMISSIONS.ZOOM_MANAGEMENT,
        PERMISSIONS.PROJECT_MANAGEMENT,
        PERMISSIONS.ADVANCED_REPORTING,
        PERMISSIONS.BASIC_SHERLOCK
      ]

    case EMPLOYEE_POSITIONS.SALES:
      return [
        PERMISSIONS.BASIC_INTERNAL,
        PERMISSIONS.ZOOM_MANAGEMENT,
        PERMISSIONS.BASIC_SHERLOCK
      ]

    case EMPLOYEE_POSITIONS.PRINCIPAL:
      return [
        PERMISSIONS.BASIC_INTERNAL,
        PERMISSIONS.ZOOM_MANAGEMENT,
        PERMISSIONS.PROJECT_MANAGEMENT,
        PERMISSIONS.ADVANCED_REPORTING,
        PERMISSIONS.BASIC_SHERLOCK
      ]
    default:
      return []
  }
}

const api = {
  PermissionCheckbox,
  getDefaultPermissionsByPosition
}

export default api
